import {USER_CONNECTED} from '../../../events/signin';
import IDENTITY_SWITCH_TPL from '../../../../resources/handlebars/main-header/identity-switch.hbs';
import INBOX_ENTRY_TPL from '../../../../resources/handlebars/main-header/inbox-entry.hbs';
import USER_IDENTITY_TPL from '../../../../resources/handlebars/main-header/user-identity.hbs';

/**
 * WARNING: all listeners set-up by this module MUST BE REMOVED by the returned destroy() function.
 */
Hop.defineModule('main-header-identities', (domRoot, param) => {
    const identitiesContainer = domRoot.querySelector('#connectedAccountIdentities');
    if (!identitiesContainer) {
        return;
    }

    const csrfToken = param.csrfToken || '';
    const elementToAddIdentitiesSwitchAfter = domRoot.querySelector('#accountLink');
    const inboxMenuEntry = domRoot.querySelector('#inboxMenuEntry');
    const userIdentity = domRoot.querySelector('#userIdentity');

    function getIdentities($container) {
        let identities;
        try {
            const json = $container.innerHTML;
            identities = JSON.parse(Hop.unescapeHtml(json));
        } catch (e) {
            identities = [];
            Hop.logError(e);
        }
        return identities;
    }

    function buildIdentityRedirectionUrl() {
        const currentUrl = new window.Url();
        delete currentUrl.query.hopsi;
        let newQueryString = currentUrl.query.toString();
        if (newQueryString) {
            newQueryString = '?' + newQueryString;
        }
        const newHash = currentUrl.hash ? '#' + currentUrl.hash : '';

        return currentUrl.path + newQueryString + newHash;
    }

    function addIdentitiesSwitchToMenu(identities) {
        const identitiesUnSelect = identities.filter((i) => !i.selected);
        const switches = identitiesUnSelect.reduce((acc, i) => {
            i.isEnforcedIdentity = param.isEnforcedIdentity;
            i.redirectionUrl = buildIdentityRedirectionUrl();
            i.csrfToken = csrfToken;
            return acc + IDENTITY_SWITCH_TPL(i);
        }, '');
        elementToAddIdentitiesSwitchAfter.insertAdjacentHTML('beforebegin', switches);
    }

    function addInboxEntriesToMenu(identities) {
        if (!identities || identities.length < 2 || !inboxMenuEntry) {
            return;
        }

        inboxMenuEntry.innerHTML = identities.reduce((acc, i) => acc + INBOX_ENTRY_TPL(i), '');
    }

    function buildSelectedUserIdentity(userInfos) {
        return {
            firstName: userInfos.firstName,
            lastName: userInfos.lastName,
            photo: userInfos.photo,
            statusType: userInfos.identities.length ? userInfos.identities.filter((i) => i.selected)[0].type : null,
        };
    }

    function addUserIdentity(userInfos) {
        userIdentity.innerHTML = USER_IDENTITY_TPL(buildSelectedUserIdentity(userInfos));
        Hop.avatar.replace($(domRoot));
    }

    function switchToConnectedMode(userInfos) {
        // new header is handled differently
        if (!userInfos.header) {
            addIdentitiesSwitchToMenu(userInfos.identities);
            addInboxEntriesToMenu(userInfos.identities);
            addUserIdentity(userInfos);
        }
    }

    function initIdentities() {
        const identities = getIdentities(identitiesContainer);
        addIdentitiesSwitchToMenu(identities);
        addInboxEntriesToMenu(identities);
        Hop.events.on(USER_CONNECTED, switchToConnectedMode);
    }

    initIdentities();

    return function destroy() {
        Hop.events.off(USER_CONNECTED, switchToConnectedMode);
    };
});
